import { render, staticRenderFns } from "./RevisionRequest.vue?vue&type=template&id=a5c8055a&scoped=true&"
import script from "./RevisionRequest.vue?vue&type=script&lang=js&"
export * from "./RevisionRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c8055a",
  null
  
)

export default component.exports